module.exports = __webpack_public_path__ + "i_live.875a8e49.gif";